import { render } from "./TheFooter.vue?vue&type=template&id=6aed1c04&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=6aed1c04&scoped=true&lang=css"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aed1c04"]])

export default __exports__